// // BuyDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371; // Earth's radius in km
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// // ─── Helper: read user location from localStorage ───────────────────────────
// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");

//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// // ─── Helper: check if displaying_pannels contains "buy_description" ─────────
// // Handles arrays of strings, comma-separated strings, or objects.
// const matchesBuyDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;

//   let values = [];

//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }

//   return values.some((v) => String(v).toLowerCase() === "buy_description");
// };

// // ─── Component ──────────────────────────────────────────────────────────────
// const BuyDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   // Get user location on mount
//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   // ─── Location-based filtering ─────────────────────────────────────────────
//   //   const filterPropertiesByLocation = (properties, location) => {
//   //     if (!location) {
//   //       setFilteredProperties([]);
//   //       return;
//   //     }

//   //     console.log("User Location:", location);
//   //     console.log("Total Properties (after buy_description filter):", properties.length);

//   //     const filtered = properties.filter((property) => {
//   //       if (!property.lat || !property.long) {
//   //         console.log(
//   //           `Property ${property.id} (${property.title}) has no coordinates - SKIPPING`
//   //         );
//   //         return false;
//   //       }

//   //       const distance = calculateDistance(
//   //         location.latitude,
//   //         location.longitude,
//   //         property.lat,
//   //         property.long
//   //       );

//   //       const radiusDistance = property.radius_distance || 10;
//   //       const isWithinRadius = distance <= radiusDistance;

//   //       property._distance = distance;
//   //       property._radius = radiusDistance;
//   //       property._isWithinRadius = isWithinRadius;

//   //       if (isWithinRadius) {
//   //         console.log(
//   //           `✅ ${property.title}: ${distance.toFixed(2)}km <= ${radiusDistance}km - SHOWING`
//   //         );
//   //       } else {
//   //         console.log(
//   //           `❌ ${property.title}: ${distance.toFixed(2)}km > ${radiusDistance}km - HIDING`
//   //         );
//   //       }

//   //       return isWithinRadius;
//   //     });

//   //     filtered.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//   //     console.log(`Filtered Properties: ${filtered.length} found`);
//   //     setFilteredProperties(filtered);
//   //   };

//   const filterPropertiesByLocation = (properties, location) => {
//     // 🔕 Location-based filtering temporarily disabled.
//     // Distance is still calculated (if location is available) so the
//     // "X km away" text keeps working, but no items are hidden.

//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true; // treat all as visible
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });

//     // Optional: sort by distance when location is available
//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }

//     console.log(
//       `[location-filter disabled] Showing all ${result.length} properties`,
//     );
//     setFilteredProperties(result);
//   };

//   // ─── Fetch + filter by buy_description ────────────────────────────────────
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=buy_description&status=true`;
//         console.log("[BuyDescriptionCard] Fetching:", url);

//         const response = await fetch(url);
//         const data = await response.json();

//         // Support multiple response shapes
//         let rawList = [];
//         if (Array.isArray(data)) {
//           rawList = data;
//         } else if (Array.isArray(data?.data)) {
//           rawList = data.data;
//         } else if (data?.data && typeof data.data === "object") {
//           // Single object shape → wrap in array
//           rawList = [data.data];
//         } else if (Array.isArray(data?.results)) {
//           rawList = data.results;
//         }

//         console.log(
//           "[BuyDescriptionCard] API response items:",
//           rawList.length,
//           "| sample:",
//           rawList[0],
//         );

//         // Safety filter — only keep items whose displaying_pannels
//         // contains "buy_description"
//         const descriptionFiltered = rawList.filter((item) =>
//           matchesBuyDescription(item.displaying_pannels),
//         );

//         console.log(
//           `[BuyDescriptionCard] After buy_description filter:`,
//           descriptionFiltered.length,
//           "items",
//         );

//         // Map to card shape
//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;

//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }

//           // Pick first hero image
//           const heroImg = item.hero_images?.[0]?.image || item.image || null;

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: item.price
//               ? `₹${Number(item.price).toLocaleString("en-IN")}`
//               : item.max_budget
//                 ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
//                 : "₹3.25 Cr",
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags || "",
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);

//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties([]);
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//         setAllProperties([]);
//         setFilteredProperties([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Re-filter when user location changes
//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties([]);
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userLocation, allProperties]);

//   // Listen for location changes from localStorage
//   useEffect(() => {
//     const handleLocationChange = () => {
//       const newLocation = getUserLocation();
//       setUserLocation(newLocation);
//     };

//     window.addEventListener("storage", handleLocationChange);

//     const interval = setInterval(() => {
//       const currentLocation = getUserLocation();
//       if (currentLocation) {
//         setUserLocation(currentLocation);
//       }
//     }, 3000);

//     return () => {
//       window.removeEventListener("storage", handleLocationChange);
//       clearInterval(interval);
//     };
//   }, []);

//   // ─── Loading skeleton ─────────────────────────────────────────────────────
//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//         <div className="property-list">
//           {[1, 2, 3].map((_, index) => (
//             <div key={index} className="featured-card skeleton-card">
//               <div className="skeleton-content">
//                 <div className="skeleton-line"></div>
//                 <div className="skeleton-line short"></div>
//                 <div className="skeleton-line medium"></div>
//                 <div className="skeleton-line"></div>
//               </div>
//               <div className="skeleton-image"></div>
//             </div>
//           ))}
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 10px;
//             background: rgb(239, 231, 221);
//           }
//           .property-list {
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .featured-card {
//             width: 100%;
//             height: 101px;
//             display: flex;
//             align-items: stretch;
//             overflow: hidden;
//             background: #fffaf4;
//             border: 1px solid #e5ddd4;
//             border-radius: 10px;
//             box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           }
//           .skeleton-card { background: #f0f0f0; }
//           .skeleton-content {
//             width: 55%;
//             padding: 12px;
//             display: flex;
//             flex-direction: column;
//             gap: 8px;
//             justify-content: center;
//           }
//           .skeleton-image {
//             width: 45%;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//           }
//           .skeleton-line {
//             height: 12px;
//             background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
//             background-size: 200% 100%;
//             animation: shimmer 1.5s infinite;
//             border-radius: 4px;
//             width: 80%;
//           }
//           .skeleton-line.short { width: 50%; }
//           .skeleton-line.medium { width: 65%; }
//           @keyframes shimmer {
//             0% { background-position: 200% 0; }
//             100% { background-position: -200% 0; }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No location ──────────────────────────────────────────────────────────
//   if (!userLocation) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>Enable Location</h3>
//             <p>Please enable location services to see properties near you.</p>
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── No nearby / no matching ──────────────────────────────────────────────
//   if (filteredProperties.length === 0) {
//     return (
//       <div className="property-wrapper">
//         <div className="no-properties-message">
//           <div className="message-content">
//             <LocationOnOutlinedIcon sx={{ fontSize: 48, color: "#8A6A3D" }} />
//             <h3>No Properties Nearby</h3>
//             <p>
//               No buy description properties found within your area.
//               <br />
//               <span style={{ fontSize: "12px", color: "#8A6A3D" }}>
//                 Try expanding your search or check back later.
//               </span>
//             </p>
//             {userLocation.address && (
//               <div
//                 style={{ fontSize: "12px", color: "#6B6350", marginTop: "8px" }}
//               >
//                 📍 {userLocation.address}
//               </div>
//             )}
//           </div>
//         </div>
//         <style>{`
//           .property-wrapper {
//             width: 100%;
//             max-width: 470px;
//             margin: 0 auto;
//             padding: 20px 10px;
//             background: rgb(239, 231, 221);
//             min-height: 200px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }
//           .no-properties-message {
//             width: 100%;
//             text-align: center;
//             padding: 30px 20px;
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//           }
//           .message-content {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 12px;
//           }
//           .message-content h3 { margin: 0; color: #2E2A22; font-size: 18px; }
//           .message-content p { margin: 0; color: #6B6350; font-size: 14px; max-width: 300px; }
//         `}</style>
//       </div>
//     );
//   }

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="property-wrapper">
//       <div className="property-list">
//         {filteredProperties.map((property) => (
//           <div key={property.id} className="featured-card">
//             {/* LEFT SIDE */}
//             <div className="featured-content">
//               <div className="building-icon">
//                 <BusinessOutlinedIcon />
//               </div>

//               <div className="featured-details">
//                 <h3>{property.title}</h3>
//                 <p className="featured-subtitle">
//                   {property.category || property.subtitle}
//                 </p>
//                 <p className="featured-price">{property.price}</p>
//                 <div className="featured-location">
//                   <LocationOnOutlinedIcon />
//                   <span>{property.location}</span>
//                 </div>
//                 {property._distance !== null && (
//                   <div className="property-distance">
//                     📍 {property._distance.toFixed(1)} km away
//                     <span className="radius-info">
//                       (Radius: {property._radius} km)
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* RIGHT SIDE IMAGE */}
//             <div className="featured-image-section">
//               <span className="badge featured-badge">{property.type}</span>
//               <img
//                 src={
//                   property.image
//                     ? `${BASE_URL}${property.image}`
//                     : "https://via.placeholder.com/300x200?text=Property"
//                 }
//                 alt={property.title}
//                 onError={(e) => {
//                   e.target.src =
//                     "https://via.placeholder.com/300x200?text=Property";
//                 }}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 470px;
//           margin: 0 auto;
//           padding: 10px;
//           background: rgb(239, 231, 221);
//         }

//         .property-list {
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//         }

//         .featured-card {
//           width: 100%;
//           height: 101px;
//           display: flex;
//           align-items: stretch;
//           overflow: hidden;
//           background: #fffaf4;
//           border: 1px solid #e5ddd4;
//           border-radius: 10px;
//           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
//           transition: transform 0.2s ease-in-out;
//         }

//         .featured-card:hover {
//           transform: scale(1.01);
//           box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
//         }

//         .featured-content {
//           width: 55%;
//           min-width: 0;
//           display: flex;
//           align-items: center;
//           padding: 9px 8px;
//           gap: 8px;
//         }

//         .building-icon {
//           width: 40px;
//           height: 40px;
//           min-width: 40px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           background: #f8ead8;
//           flex-shrink: 0;
//         }

//         .building-icon svg {
//           font-size: 25px;
//           color: #6c4a2d;
//         }

//         .featured-details {
//           min-width: 0;
//           flex: 1;
//           overflow: hidden;
//         }

//         .featured-details h3 {
//           margin: 0;
//           color: #242424;
//           font-size: 14px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-subtitle {
//           margin: 1px 0 3px;
//           color: #333;
//           font-size: 9.5px;
//           line-height: 12px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-price {
//           margin: 0 0 3px;
//           color: #b65f13;
//           font-size: 15px;
//           font-weight: 700;
//           line-height: 17px;
//           white-space: nowrap;
//         }

//         .featured-location {
//           width: 100%;
//           display: flex;
//           align-items: center;
//           gap: 3px;
//           color: #333;
//           font-size: 9px;
//           line-height: 12px;
//           overflow: hidden;
//         }

//         .featured-location svg {
//           width: 13px;
//           height: 13px;
//           min-width: 13px;
//           color: #b66a18;
//         }

//         .featured-location span {
//           min-width: 0;
//           overflow: hidden;
//           white-space: nowrap;
//           text-overflow: ellipsis;
//         }

//         .property-distance {
//           font-size: 8px;
//           color: #8A6A3D;
//           font-weight: 600;
//           margin-top: 2px;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }

//         .radius-info {
//           font-weight: 400;
//           color: #6B6350;
//           font-size: 7px;
//         }

//         .featured-image-section {
//           position: relative;
//           width: 45%;
//           min-width: 0;
//           overflow: hidden;
//           flex-shrink: 0;
//         }

//         .featured-image-section img {
//           width: 100%;
//           height: 100%;
//           display: block;
//           object-fit: cover;
//           object-position: center;
//         }

//         .badge {
//           position: absolute;
//           top: 5px;
//           left: 6px;
//           z-index: 5;
//           padding: 4px 9px;
//           border-radius: 12px;
//           background: #b87829;
//           color: #fff;
//           font-size: 9px;
//           font-weight: 700;
//           line-height: 12px;
//           white-space: nowrap;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
//         }

//         @media (max-width: 380px) {
//           .property-wrapper { padding: 8px; }
//           .property-list { gap: 7px; }
//           .featured-card { height: 96px; }
//           .featured-content { width: 56%; padding: 7px 6px; gap: 6px; }
//           .featured-image-section { width: 44%; }
//           .building-icon { width: 36px; height: 36px; min-width: 36px; }
//           .building-icon svg { font-size: 22px; }
//           .featured-details h3 { font-size: 13px; }
//           .featured-subtitle { font-size: 8.5px; }
//           .featured-price { font-size: 14px; }
//           .featured-location { font-size: 8px; }
//         }

//         @media (min-width: 768px) {
//           .property-wrapper { max-width: 1200px; padding: 20px 40px; }
//           .property-list { gap: 16px; }
//           .featured-card { height: 140px; }
//           .featured-content { width: 52%; padding: 14px 18px; gap: 12px; }
//           .featured-image-section { width: 48%; }
//           .building-icon { width: 52px; height: 52px; min-width: 52px; }
//           .building-icon svg { font-size: 32px; }
//           .featured-details h3 { font-size: 18px; line-height: 22px; }
//           .featured-subtitle { font-size: 11px; line-height: 14px; }
//           .featured-price { font-size: 19px; line-height: 22px; }
//           .featured-location { font-size: 10px; }
//           .badge { top: 8px; left: 10px; padding: 5px 11px; font-size: 10px; }
//           .property-distance { font-size: 10px; }
//           .radius-info { font-size: 9px; }
//         }

//         @media (min-width: 1024px) {
//           .property-wrapper { max-width: 1400px; }
//           .featured-card { height: 160px; }
//           .featured-content { width: 45%; padding: 18px 24px; }
//           .featured-image-section { width: 55%; }
//           .featured-details h3 { font-size: 20px; line-height: 24px; }
//           .featured-price { font-size: 22px; line-height: 26px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BuyDescriptionCard;




// // BuyDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371; // Earth's radius in km
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// // ─── Helper: read user location from localStorage ───────────────────────────
// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");

//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// // ─── Helper: check if displaying_pannels contains "buy_description" ─────────
// const matchesBuyDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;

//   let values = [];

//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }

//   return values.some((v) => String(v).toLowerCase() === "buy_description");
// };

// // ─── Helper: Format Price to Cr / Lakhs ─────────────────────────────────────
// const formatPrice = (price) => {
//   if (!price) return "Price on request";
//   const num = Number(price);
//   if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
//   if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
//   return `₹${num.toLocaleString("en-IN")}`;
// };

// // ─── Component ──────────────────────────────────────────────────────────────
// const BuyDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   // Get user location on mount
//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   const filterPropertiesByLocation = (properties, location) => {
//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true;
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });

//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }
//     setFilteredProperties(result);
//   };

//   // ─── Fetch + filter by buy_description ────────────────────────────────────
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=buy_description&status=true`;
//         const response = await fetch(url);
//         const data = await response.json();

//         let rawList = [];
//         if (Array.isArray(data)) rawList = data;
//         else if (Array.isArray(data?.data)) rawList = data.data;
//         else if (data?.data && typeof data.data === "object") rawList = [data.data];
//         else if (Array.isArray(data?.results)) rawList = data.results;

//         const descriptionFiltered = rawList.filter((item) =>
//           matchesBuyDescription(item.displaying_pannels),
//         );

//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;

//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }

//           const heroImg = item.hero_images?.[0]?.image || item.image || null;
          
//           // Generate fake tags for UI matching if not present in API
//           const mockTags = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "Pent House"];

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: formatPrice(item.price || item.max_budget),
//             rawPrice: item.price || item.max_budget || 0,
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags ? item.tags.split(',') : mockTags, // Use API tags or mock tags
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);

//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties(propertyData); // Show all if no location
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, []);

//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties(allProperties);
//       }
//     }
//   }, [userLocation, allProperties]);

//   // ─── Loading skeleton ─────────────────────────────────────────────────────
//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//          <div className="skeleton-featured"></div>
//          <div className="skeleton-grid">
//             <div className="skeleton-box"></div>
//             <div className="skeleton-box"></div>
//          </div>
//          <style>{`
//             .property-wrapper { width: 100%; padding: 10px; background: rgb(239, 231, 221); }
//             .skeleton-featured { height: 180px; background: #e0e0e0; border-radius: 12px; margin-bottom: 15px; animation: pulse 1.5s infinite; }
//             .skeleton-grid { display: flex; gap: 10px; }
//             .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
//             @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
//          `}</style>
//       </div>
//     );
//   }

//   if (filteredProperties.length === 0) {
//      return null; // Or your empty state UI
//   }

//   const featuredProperty = filteredProperties[0];
//   const gridProperties = filteredProperties.slice(1);

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div className="property-wrapper">
      
//       {/* 1. FEATURED CARD (Top Large Horizontal) */}
//       {featuredProperty && (
//         <div className="featured-card-large">
//           <div className="featured-content-left">
            
//             {/* Top Icon */}
//             <div className="building-icon">
//               <BusinessOutlinedIcon />
//             </div>

//             {/* Price Section */}
//             <div className="price-section">
//               <h2 className="featured-price">{featuredProperty.price}</h2>
//               <p className="featured-psf">$9000 per Sqft</p> {/* Placeholder or dynamic */}
//             </div>

//             {/* Pills / Tags */}
//             <div className="tags-container">
//               {featuredProperty.tags.slice(0, 6).map((tag, idx) => (
//                 <span key={idx} className="tag-pill">{tag}</span>
//               ))}
//             </div>

//             {/* Title & Location */}
//             <h3 className="featured-title">{featuredProperty.title}</h3>
//             <p className="featured-location-text">{featuredProperty.location}</p>
//           </div>

//           <div className="featured-image-right">
//             <span className="badge featured-badge">Featured</span>
//             <img
//               src={featuredProperty.image ? `${BASE_URL}${featuredProperty.image}` : "https://via.placeholder.com/300x400?text=Property"}
//               alt={featuredProperty.title}
//               onError={(e) => { e.target.src = "https://via.placeholder.com/300x400?text=Property"; }}
//             />
//           </div>
//         </div>
//       )}

//       {/* 2. GRID CARDS (Bottom 2-Column Grid) */}
//       <div className="property-grid">
//         {gridProperties.map((property, index) => {
//            // Alternate badges for visual variety based on screenshot
//            const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
//            const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

//            return (
//             <div key={property.id} className="grid-card">
//               <div className="grid-image-section">
//                 <span className={`badge ${badgeClass}`}>{badgeText}</span>
//                 <img
//                   src={property.image ? `${BASE_URL}${property.image}` : "https://via.placeholder.com/200x200?text=Property"}
//                   alt={property.title}
//                   onError={(e) => { e.target.src = "https://via.placeholder.com/200x200?text=Property"; }}
//                 />
//               </div>
//               <div className="grid-content-section">
//                 <h4 className="grid-title">{property.title}</h4>
//                 <p className="grid-location">{property.location}</p>
//                 <p className="grid-price">{property.price}</p>
//                 <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p> {/* Placeholder for property specs */}
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* ─── CSS STYLES ────────────────────────────────────────────────────── */}
//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 500px; /* Constrain width for mobile view like screenshot */
//           margin: 0 auto;
//           padding: 5px;
//           // background: rgb(239, 231, 221);
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
//         }

//         /* ── FEATURED LARGE CARD ── */
//         .featured-card-large {
//           display: flex;
//           background: #fdfaf6;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//           margin-bottom: 12px;
//           min-height: 140px;
//         }

//         .featured-content-left {
//           flex: 1;
//           padding: 16px 14px;
//           display: flex;
//           flex-direction: column;
//           justify-content: flex-start;
//         }

//         .building-icon {
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           background: #f0e6d8;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 12px;
//         }
//         .building-icon svg {
//           color: #8c6b4a;
//           font-size: 20px;
//         }

//         .price-section {
//           margin-bottom: 12px;
//         }
//         .featured-price {
//           margin: 0;
//           font-size: 18px;
//           font-weight: 800;
//           color: #6d4626;
//         }
//         .featured-psf {
//           margin: 2px 0 0 0;
//           font-size: 11px;
//           color: #6d4626;
//           font-weight: 600;
//         }

//         .tags-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 4px;
//           margin-bottom: 12px;
//         }
//         .tag-pill {
//           background: #eaddcf;
//           color: #4a3524;
//           font-size: 9px;
//           font-weight: 600;
//           padding: 3px 8px;
//           border-radius: 12px;
//         }

//         .featured-title {
//           margin: 0 0 4px 0;
//           font-size: 16px;
//           font-weight: 800;
//           color: #1a1a1a;
//           line-height: 1.2;
//         }
//         .featured-location-text {
//           margin: 0;
//           font-size: 11px;
//           color: #555;
//           font-weight: 500;
//         }

//         .featured-image-right {
//           width: 45%;
//           position: relative;
//         }
//         .featured-image-right img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }

//         /* ── GRID CARDS (2 IN A ROW) ── */
//         .property-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 10px;
//         }

//         .grid-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 3px 10px rgba(0,0,0,0.06);
//           display: flex;
//           flex-direction: column;
//         }

//         .grid-image-section {
//           position: relative;
//           width: 100%;
//           height: 130px;
//         }
//         .grid-image-section img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .grid-content-section {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 3px;
//         }

//         .grid-title {
//           margin: 0;
//           font-size: 13px;
//           font-weight: 800;
//           color: #111;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-location {
//           margin: 0;
//           font-size: 10px;
//           color: #666;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-price {
//           margin: 3px 0 0 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #d15b1e; /* Reddish-orange matching screenshot */
//         }
//         .grid-details {
//           margin: 0;
//           font-size: 9px;
//           color: #888;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute;
//           top: 8px;
//           left: 8px;
//           padding: 3px 8px;
//           border-radius: 10px;
//           font-size: 9px;
//           font-weight: 700;
//           color: #fff;
//           z-index: 2;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.2);
//         }
//         .featured-badge {
//           background: #a87c51;
//         }
//         .badge-new {
//           background: #a3a38f; /* Muted green/grey matching screenshot */
//         }
//         .badge-premium {
//           background: #d1a47e; /* Muted brown matching screenshot */
//         }

//         @media (max-width: 360px) {
//           .grid-image-section { height: 110px; }
//           .featured-title { font-size: 14px; }
//           .grid-title { font-size: 12px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BuyDescriptionCard;


// // BuyDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");
//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// const matchesBuyDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;
//   let values = [];
//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }
//   return values.some((v) => String(v).toLowerCase() === "buy_description");
// };

// const formatPrice = (price) => {
//   if (!price) return "Price on request";
//   const num = Number(price);
//   if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
//   if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
//   return `₹${num.toLocaleString("en-IN")}`;
// };

// const BuyDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   const filterPropertiesByLocation = (properties, location) => {
//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true;
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });
//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }
//     setFilteredProperties(result);
//   };

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=buy_description&status=true`;
//         const response = await fetch(url);
//         const data = await response.json();

//         let rawList = [];
//         if (Array.isArray(data)) rawList = data;
//         else if (Array.isArray(data?.data)) rawList = data.data;
//         else if (data?.data && typeof data.data === "object") rawList = [data.data];
//         else if (Array.isArray(data?.results)) rawList = data.results;

//         const descriptionFiltered = rawList.filter((item) =>
//           matchesBuyDescription(item.displaying_pannels),
//         );

//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;
//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }
//           const heroImg = item.hero_images?.[0]?.image || item.image || null;
//           const mockTags = ["1 BHK", "2 BHK", "3 BHK"];

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: formatPrice(item.price || item.max_budget),
//             rawPrice: item.price || item.max_budget || 0,
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags ? item.tags.split(',') : mockTags,
//             pricePerSft: item.price_per_sqft ? `₹${item.price_per_sqft} per Sft` : "₹9000 per Sft",
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);
//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties(propertyData);
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperties();
//   }, []);

//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties(allProperties);
//       }
//     }
//   }, [userLocation, allProperties]);

//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//          <div className="skeleton-featured"></div>
//          <div className="skeleton-grid">
//             <div className="skeleton-box"></div>
//             <div className="skeleton-box"></div>
//          </div>
//          <style>{`
//             .property-wrapper { width: 100%; padding: 10px; background: rgb(239, 231, 221); }
//             .skeleton-featured { height: 145px; background: #e0e0e0; border-radius: 12px; margin-bottom: 15px; animation: pulse 1.5s infinite; }
//             .skeleton-grid { display: flex; gap: 10px; }
//             .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
//             @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
//          `}</style>
//       </div>
//     );
//   }

//   if (filteredProperties.length === 0) {
//      return null;
//   }

//   // ✅ Only take first 3 properties: 1 featured + 2 grid
//   const featuredProperty = filteredProperties[0];
//   const gridProperties = filteredProperties.slice(1, 3);

//   return (
//     <div className="property-wrapper">
      
//       {/* 1. FEATURED CARD — matches FeaturedPropertyCard layout */}
//       {featuredProperty && (
//         <div className="featured-card-large">
          
//           {/* LEFT CONTENT */}
//           <div className="featured-content-left">
//             <div>
//               {/* PRICE + ICON ROW */}
//               <div className="price-icon-row">
//                 <div className="building-icon-circle">
//                   <BusinessOutlinedIcon className="building-icon-svg" />
//                 </div>
//                 <div className="price-text-block">
//                   <h2 className="featured-price">{featuredProperty.price}</h2>
//                   <p className="featured-psf">{featuredProperty.pricePerSft}</p>
//                 </div>
//               </div>

//               {/* BHK / TAGS PILLS ROW */}
//               <div className="tags-container">
//                 {featuredProperty.tags.slice(0, 3).map((tag, idx) => (
//                   <span key={idx} className="tag-pill">{tag}</span>
//                 ))}
//               </div>
//             </div>

//             {/* TITLE + LOCATION (Bottom Center) */}
//             <div className="title-location-block">
//               <h3 className="featured-title">{featuredProperty.title}</h3>
//               <p className="featured-location-text">{featuredProperty.location}</p>
//             </div>
//           </div>

//           {/* RIGHT IMAGE */}
//           <div className="featured-image-right">
//             <span className="badge featured-badge">Featured</span>
//             <img
//               src={featuredProperty.image ? `${BASE_URL}${featuredProperty.image}` : "https://via.placeholder.com/300x400?text=Property"}
//               alt={featuredProperty.title}
//               onError={(e) => { e.target.src = "https://via.placeholder.com/300x400?text=Property"; }}
//             />
//           </div>
//         </div>
//       )}

//       {/* 2. GRID CARDS — only 2 cards rendered */}
//       {gridProperties.length > 0 && (
//         <div className="property-grid">
//           {gridProperties.map((property, index) => {
//              const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
//              const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

//              return (
//               <div key={property.id} className="grid-card">
//                 <div className="grid-image-section">
//                   <span className={`badge ${badgeClass}`}>{badgeText}</span>
//                   <img
//                     src={property.image ? `${BASE_URL}${property.image}` : "https://via.placeholder.com/200x200?text=Property"}
//                     alt={property.title}
//                     onError={(e) => { e.target.src = "https://via.placeholder.com/200x200?text=Property"; }}
//                   />
//                 </div>
//                 <div className="grid-content-section">
//                   <h4 className="grid-title">{property.title}</h4>
//                   <p className="grid-location">{property.location}</p>
//                   <p className="grid-price">{property.price}</p>
//                   <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* ─── CSS STYLES ────────────────────────────────────────────────────── */}
//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 500px;
//           margin: 0 auto;
//           padding: 5px;
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
//         }

//         /* ── FEATURED LARGE CARD ── */
//         .featured-card-large {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           background: #F7F2EA;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//           margin-bottom: 12px;
//           min-height: 145px;
//         }

//         .featured-content-left {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           min-width: 0;
//           background: #F7F2EA;
//         }

//         .price-icon-row {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .building-icon-circle {
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           background: transparent;
//           border: 1px solid #000000;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//         }

//         .building-icon-svg {
//           color: #000000;
//           font-size: 18px;
//         }

//         .price-text-block {
//           min-width: 0;
//         }

//         .featured-price {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #5B4526;
//           white-space: nowrap;
//         }

//         .featured-psf {
//           margin: 1px 0 0 0;
//           font-size: 10px;
//           font-weight: 700;
//           color: #1E1B16;
//         }

//         .tags-container {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 4px;
//           margin-top: 10px;
//         }

//         .tag-pill {
//           background: #cec7c7;
//           color: #333333;
//           font-size: 9px;
//           font-weight: 600;
//           padding: 3px 4px;
//           border-radius: 20px;
//           text-align: center;
//           white-space: nowrap;
//           border: 1px solid #f0ebe4;
//         }

//         .title-location-block {
//           text-align: center;
//           margin-top: 8px;
//         }

//         .featured-title {
//           margin: 0;
//           font-size: 12px;
//           font-weight: 800;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-location-text {
//           margin: 3px 0 0 0;
//           font-size: 10px;
//           font-weight: 600;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-image-right {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           min-height: 145px;
//           overflow: hidden;
//         }

//         .featured-image-right img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }

//         /* ── GRID CARDS (2 IN A ROW) ── */
//         .property-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 10px;
//         }

//         .grid-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 3px 10px rgba(0,0,0,0.06);
//           display: flex;
//           flex-direction: column;
//         }

//         .grid-image-section {
//           position: relative;
//           width: 100%;
//           height: 130px;
//         }
//         .grid-image-section img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .grid-content-section {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 3px;
//         }

//         .grid-title {
//           margin: 0;
//           font-size: 13px;
//           font-weight: 800;
//           color: #111;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-location {
//           margin: 0;
//           font-size: 10px;
//           color: #666;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-price {
//           margin: 3px 0 0 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #d15b1e;
//         }
//         .grid-details {
//           margin: 0;
//           font-size: 9px;
//           color: #888;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute;
//           top: 8px;
//           left: 8px;
//           padding: 3px 8px;
//           border-radius: 10px;
//           font-size: 9px;
//           font-weight: 700;
//           color: #fff;
//           z-index: 2;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.2);
//         }
//         .featured-badge {
//           background: #a87c51;
//         }
//         .badge-new {
//           background: #a3a38f;
//         }
//         .badge-premium {
//           background: #d1a47e;
//         }

//         @media (max-width: 360px) {
//           .grid-image-section { height: 110px; }
//           .featured-title { font-size: 11px; }
//           .grid-title { font-size: 12px; }
//           .featured-card-large { min-height: 130px; }
//           .building-icon-circle { width: 28px; height: 28px; }
//           .building-icon-svg { font-size: 16px; }
//           .featured-price { font-size: 13px; }
//           .featured-psf { font-size: 9px; }
//           .tag-pill { font-size: 8px; padding: 2px 3px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BuyDescriptionCard;


// // BuyDescriptionCard.js
// import React, { useState, useEffect } from "react";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─── Helper: Haversine distance (km) ────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");
//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// const matchesBuyDescription = (displayingPannels) => {
//   if (!displayingPannels) return false;
//   let values = [];
//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v),
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }
//   return values.some((v) => String(v).toLowerCase() === "buy_description");
// };

// const formatPrice = (price) => {
//   if (!price) return "Price on request";
//   const num = Number(price);
//   if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
//   if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
//   return `₹${num.toLocaleString("en-IN")}`;
// };

// const BuyDescriptionCard = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   useEffect(() => {
//     const location = getUserLocation();
//     setUserLocation(location);
//     setLocationLoading(false);
//   }, []);

//   const filterPropertiesByLocation = (properties, location) => {
//     const result = properties.map((property) => {
//       if (location && property.lat && property.long) {
//         const distance = calculateDistance(
//           location.latitude,
//           location.longitude,
//           property.lat,
//           property.long,
//         );
//         property._distance = distance;
//         property._radius = property.radius_distance || 10;
//         property._isWithinRadius = true;
//       } else {
//         property._distance = null;
//         property._radius = null;
//         property._isWithinRadius = true;
//       }
//       return property;
//     });
//     if (location) {
//       result.sort((a, b) => (a._distance || 0) - (b._distance || 0));
//     }
//     setFilteredProperties(result);
//   };

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=buy_description&status=true`;
//         const response = await fetch(url);
//         const data = await response.json();

//         let rawList = [];
//         if (Array.isArray(data)) rawList = data;
//         else if (Array.isArray(data?.data)) rawList = data.data;
//         else if (data?.data && typeof data.data === "object") rawList = [data.data];
//         else if (Array.isArray(data?.results)) rawList = data.results;

//         const descriptionFiltered = rawList.filter((item) =>
//           matchesBuyDescription(item.displaying_pannels),
//         );

//         const propertyData = descriptionFiltered.map((item) => {
//           let lat = null;
//           let long = null;
//           let radiusDistance = null;
//           if (item.lat && item.long) {
//             lat = parseFloat(item.lat);
//             long = parseFloat(item.long);
//           }
//           if (item.radius_distance) {
//             radiusDistance = parseFloat(item.radius_distance);
//           }
//           const heroImg = item.hero_images?.[0]?.image || item.image || null;
//           const mockTags = ["1 BHK", "2 BHK", "3 BHK"];

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: formatPrice(item.price || item.max_budget),
//             rawPrice: item.price || item.max_budget || 0,
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: item.tags ? item.tags.split(',') : mockTags,
//             pricePerSft: item.price_per_sqft ? `₹${item.price_per_sqft} per Sft` : "₹9000 per Sft",
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             _distance: null,
//             _radius: null,
//             _isWithinRadius: false,
//           };
//         });

//         setAllProperties(propertyData);
//         if (userLocation) {
//           filterPropertiesByLocation(propertyData, userLocation);
//         } else {
//           setFilteredProperties(propertyData);
//         }
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//         setError("Error loading properties");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperties();
//   }, []);

//   useEffect(() => {
//     if (allProperties.length > 0) {
//       if (userLocation) {
//         filterPropertiesByLocation(allProperties, userLocation);
//       } else {
//         setFilteredProperties(allProperties);
//       }
//     }
//   }, [userLocation, allProperties]);

//   if (loading || locationLoading) {
//     return (
//       <div className="property-wrapper">
//          <div className="skeleton-featured"></div>
//          <div className="skeleton-grid">
//             <div className="skeleton-box"></div>
//             <div className="skeleton-box"></div>
//          </div>
//          <style>{`
//             .property-wrapper { width: 100%; padding: 10px; background: rgb(239, 231, 221); }
//             .skeleton-featured { height: 145px; background: #e0e0e0; border-radius: 12px; margin-bottom: 15px; animation: pulse 1.5s infinite; }
//             .skeleton-grid { display: flex; gap: 10px; }
//             .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
//             @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
//          `}</style>
//       </div>
//     );
//   }

//   if (filteredProperties.length === 0) {
//      return null;
//   }

//   // ✅ Only take first 3 properties: 1 featured + 2 grid
//   const featuredProperty = filteredProperties[0];
//   const gridProperties = filteredProperties.slice(1, 3);

//   return (
//     <div className="property-wrapper">
      
//       {/* 1. FEATURED CARD — matches FeaturedPropertyCard layout */}
//       {featuredProperty && (
//         <div className="featured-card-large">
          
//           {/* LEFT CONTENT */}
//           <div className="featured-content-left">
//             <div>
//               {/* PRICE + ICON ROW */}
//               <div className="price-icon-row">
//                 <div className="building-icon-circle">
//                   <BusinessOutlinedIcon className="building-icon-svg" />
//                 </div>
//                 <div className="price-text-block">
//                   <h2 className="featured-price">{featuredProperty.price}</h2>
//                   <p className="featured-psf">{featuredProperty.pricePerSft}</p>
//                 </div>
//               </div>

//               {/* BHK / TAGS PILLS ROW */}
//               <div className="tags-container">
//                 {featuredProperty.tags.slice(0, 3).map((tag, idx) => (
//                   <span key={idx} className="tag-pill">{tag}</span>
//                 ))}
//               </div>
//             </div>

//             {/* TITLE + LOCATION (Bottom Center) */}
//             <div className="title-location-block">
//               <h3 className="featured-title">{featuredProperty.title}</h3>
//               <p className="featured-location-text">{featuredProperty.location}</p>
//             </div>
//           </div>

//           {/* RIGHT IMAGE */}
//           <div className="featured-image-right">
//             <span className="badge featured-badge">Featured</span>
//             <img
//               src={featuredProperty.image ? `${BASE_URL}${featuredProperty.image}` : "https://via.placeholder.com/300x400?text=Property"}
//               alt={featuredProperty.title}
//               onError={(e) => { e.target.src = "https://via.placeholder.com/300x400?text=Property"; }}
//             />
//           </div>
//         </div>
//       )}

//       {/* 2. GRID CARDS — only 2 cards rendered */}
//       {gridProperties.length > 0 && (
//         <div className="property-grid">
//           {gridProperties.map((property, index) => {
//              const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
//              const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

//              return (
//               <div key={property.id} className="grid-card">
//                 <div className="grid-image-section">
//                   <span className={`badge ${badgeClass}`}>{badgeText}</span>
//                   <img
//                     src={property.image ? `${BASE_URL}${property.image}` : "https://via.placeholder.com/200x200?text=Property"}
//                     alt={property.title}
//                     onError={(e) => { e.target.src = "https://via.placeholder.com/200x200?text=Property"; }}
//                   />
//                 </div>
//                 <div className="grid-content-section">
//                   <h4 className="grid-title">{property.title}</h4>
//                   <p className="grid-location">{property.location}</p>
//                   <p className="grid-price">{property.price}</p>
//                   <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* ─── CSS STYLES ────────────────────────────────────────────────────── */}
//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 500px;
//           margin: 0 auto;
//           padding: 5px;
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
//         }

//         /* ── FEATURED LARGE CARD ── */
//         .featured-card-large {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           background: #F7F2EA;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//           margin-bottom: 12px;
//           height: 145px;                /* ✅ FIXED HEIGHT (was min-height) */
//         }

//         .featured-content-left {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           min-width: 0;
//           min-height: 0;                /* ✅ allows shrink inside fixed-height grid */
//           background: #F7F2EA;
//           overflow: hidden;
//         }

//         .price-icon-row {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .building-icon-circle {
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           background: transparent;
//           border: 1px solid #000000;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//         }

//         .building-icon-svg {
//           color: #000000;
//           font-size: 18px;
//         }

//         .price-text-block {
//           min-width: 0;
//         }

//         .featured-price {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #5B4526;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-psf {
//           margin: 1px 0 0 0;
//           font-size: 14px;
//           font-weight: 700;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .tags-container {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 4px;
//           margin-top: 10px;
//         }

//         .tag-pill {
//           background: #cec7c7;
//           color: #333333;
//           font-size: 11px;
//           font-weight: 600;
//           padding: 3px 4px;
//           border-radius: 20px;
//           text-align: center;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           border: 1px solid #f0ebe4;
//         }

//         .title-location-block {
//           text-align: center;
//           margin-top: 8px;
//         }

//         .featured-title {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-location-text {
//           margin: 3px 0 0 0;
//           font-size: 10px;
//           font-weight: 600;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         /* ✅ FIXED: image container has fixed height via grid row (145px) */
//         .featured-image-right {
//           position: relative;
//           width: 100%;
//           height: 100%;                 /* fills the 145px grid row */
//           overflow: hidden;
//           background: #E8DFD1;          /* fallback bg while loading */
//         }

//         .featured-image-right img {
//           position: absolute;           /* ✅ takes it out of flow */
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;            /* ✅ crops cleanly */
//           object-position: center;
//           display: block;
//         }

//         /* ── GRID CARDS (2 IN A ROW) ── */
//         .property-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 10px;
//         }

//         .grid-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 3px 10px rgba(0,0,0,0.06);
//           display: flex;
//           flex-direction: column;
//         }

//         /* ✅ FIXED: fixed height + relative positioning for overlay img */
//         .grid-image-section {
//           position: relative;
//           width: 100%;
//           height: 130px;                /* fixed height regardless of image */
//           overflow: hidden;
//           background: #EEE7DD;
//         }
//         .grid-image-section img {
//           position: absolute;           /* ✅ removes aspect-ratio influence */
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;            /* ✅ crops cleanly */
//           object-position: center;
//           display: block;
//         }

//         .grid-content-section {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 3px;
//           min-height: 0;
//         }

//         .grid-title {
//           margin: 0;
//           font-size: 13px;
//           font-weight: 800;
//           color: #111;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-location {
//           margin: 0;
//           font-size: 10px;
//           color: #666;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .grid-price {
//           margin: 3px 0 0 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #d15b1e;
//         }
//         .grid-details {
//           margin: 0;
//           font-size: 9px;
//           color: #888;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute;
//           top: 8px;
//           left: 8px;
//           padding: 3px 8px;
//           border-radius: 10px;
//           font-size: 9px;
//           font-weight: 700;
//           color: #fff;
//           z-index: 2;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.2);
//         }
//         .featured-badge {
//           background: #a87c51;
//         }
//         .badge-new {
//           background: #a3a38f;
//         }
//         .badge-premium {
//           background: #d1a47e;
//         }

//         @media (max-width: 360px) {
//           .grid-image-section { height: 110px; }
//           .featured-title { font-size: 11px; }
//           .grid-title { font-size: 12px; }
//           .featured-card-large { height: 130px; }   /* ✅ was min-height */
//           .building-icon-circle { width: 28px; height: 28px; }
//           .building-icon-svg { font-size: 16px; }
//           .featured-price { font-size: 13px; }
//           .featured-psf { font-size: 9px; }
//           .tag-pill { font-size: 8px; padding: 2px 3px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BuyDescriptionCard;



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { BASE_URL } from "../../Api/ApiUrls";

// ─── Helper: Haversine distance (km) ────────────────────────────────────────
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const getUserLocation = () => {
  const lat = localStorage.getItem("userLatitude");
  const lng = localStorage.getItem("userLongitude");
  const address = localStorage.getItem("userLocation");
  if (lat && lng) {
    return {
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      address: address || "Current Location",
    };
  }
  return null;
};

const matchesBuyDescription = (displayingPannels) => {
  if (!displayingPannels) return false;
  let values = [];
  if (Array.isArray(displayingPannels)) {
    values = displayingPannels.map((v) =>
      typeof v === "string" ? v : v?.name || v?.value || String(v),
    );
  } else if (typeof displayingPannels === "string") {
    values = displayingPannels.split(",").map((s) => s.trim());
  } else if (typeof displayingPannels === "object") {
    values = Object.values(displayingPannels).map(String);
  } else {
    values = [String(displayingPannels)];
  }
  return values.some((v) => String(v).toLowerCase() === "buy_description");
};

const formatPrice = (price) => {
  if (!price) return "Price on request";
  const num = Number(price);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
};

const BuyDescriptionCard = () => {
  const navigate = useNavigate();

  const [allProperties, setAllProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [locationLoading, setLocationLoading] = useState(true);

  useEffect(() => {
    const location = getUserLocation();
    setUserLocation(location);
    setLocationLoading(false);
  }, []);

  // ─── Location-based filtering (radius check ENABLED) ─────────────────────
  const filterPropertiesByLocation = (properties, location) => {
    if (!location) {
      setFilteredProperties([]);
      return;
    }

    const filtered = properties.filter((property) => {
      // Skip properties without coordinates
      if (!property.lat || !property.long) return false;

      const distance = calculateDistance(
        location.latitude,
        location.longitude,
        property.lat,
        property.long,
      );

      const radiusDistance = property.radius_distance || 10;
      const isWithinRadius = distance <= radiusDistance;

      property._distance = distance;
      property._radius = radiusDistance;
      property._isWithinRadius = isWithinRadius;

      return isWithinRadius;
    });

    // Sort by nearest first
    filtered.sort((a, b) => (a._distance || 0) - (b._distance || 0));
    setFilteredProperties(filtered);
  };

  // ─── Fetch ────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        const url = `${BASE_URL}/ad-properties/performance/?displaying_pannels=buy_description&status=true`;
        const response = await fetch(url);
        const data = await response.json();

        let rawList = [];
        if (Array.isArray(data)) rawList = data;
        else if (Array.isArray(data?.data)) rawList = data.data;
        else if (data?.data && typeof data.data === "object") rawList = [data.data];
        else if (Array.isArray(data?.results)) rawList = data.results;

        const descriptionFiltered = rawList.filter((item) =>
          matchesBuyDescription(item.displaying_pannels),
        );

        const propertyData = descriptionFiltered.map((item) => {
          let lat = null;
          let long = null;
          let radiusDistance = null;
          if (item.lat && item.long) {
            lat = parseFloat(item.lat);
            long = parseFloat(item.long);
          }
          if (item.radius_distance) {
            radiusDistance = parseFloat(item.radius_distance);
          }
          const heroImg = item.hero_images?.[0]?.image || item.image || null;
          const mockTags = ["1 BHK", "2 BHK", "3 BHK"];

          return {
            id: item.property_id ?? item.id,
            type: item.property_type || "Premium",
            title: item.property_name || "Property",
            subtitle: item.property_type || "Premium Apartments",
            price: formatPrice(item.price || item.max_budget),
            rawPrice: item.price || item.max_budget || 0,
            location: item.address || item.city || "Location not specified",
            image: heroImg,
            category: item.category_name || "",
            tags: item.tags ? item.tags.split(",") : mockTags,
            pricePerSft: item.price_per_sqft
              ? `₹${item.price_per_sqft} per Sft`
              : "₹9000 per Sft",
            description: item.description || "",
            lat,
            long,
            radius_distance: radiusDistance,
            displaying_pannels: item.displaying_pannels,
            _distance: null,
            _radius: null,
            _isWithinRadius: false,
          };
        });

        setAllProperties(propertyData);
        if (userLocation) {
          filterPropertiesByLocation(propertyData, userLocation);
        } else {
          setFilteredProperties([]);
        }
      } catch (err) {
        console.error("Error fetching properties:", err);
        setError("Error loading properties");
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Re-filter when user location changes
  useEffect(() => {
    if (allProperties.length > 0) {
      if (userLocation) {
        filterPropertiesByLocation(allProperties, userLocation);
      } else {
        setFilteredProperties([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLocation, allProperties]);

  // ─── Loading skeleton ─────────────────────────────────────────────────────
  if (loading || locationLoading) {
    return (
      <div className="property-wrapper">
        <div className="skeleton-featured"></div>
        <div className="skeleton-grid">
          <div className="skeleton-box"></div>
          <div className="skeleton-box"></div>
        </div>
        <style>{`
          .property-wrapper { width: 100%; padding: 10px; background: rgb(239, 231, 221); }
          .skeleton-featured { height: 145px; background: #e0e0e0; border-radius: 12px; margin-bottom: 15px; animation: pulse 1.5s infinite; }
          .skeleton-grid { display: flex; gap: 10px; }
          .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
          @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
        `}</style>
      </div>
    );
  }

  // ─── No location → prompt user ────────────────────────────────────────────
  // if (!userLocation) {
  //   return (
  //     <div className="property-wrapper">
  //       <div className="no-location-box">
  //         <LocationOnOutlinedIcon sx={{ fontSize: 42, color: "#8A6A3D" }} />
  //         <h3>Enable Location</h3>
  //         <p>Please enable location to see properties near you.</p>
  //       </div>
  //       <style>{`
  //         .property-wrapper { width: 100%; padding: 20px 10px; background: rgb(239, 231, 221); }
  //         .no-location-box {
  //           background: #fff;
  //           border-radius: 12px;
  //           padding: 30px 20px;
  //           text-align: center;
  //           box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  //         }
  //         .no-location-box h3 { margin: 10px 0 6px; color: #2E2A22; font-size: 16px; }
  //         .no-location-box p  { margin: 0; color: #6B6350; font-size: 13px; }
  //       `}</style>
  //     </div>
  //   );
  // }

  // ─── No nearby properties ────────────────────────────────────────────────
  // if (filteredProperties.length === 0) {
  //   return (
  //     <div className="property-wrapper">
  //       <div className="no-location-box">
  //         <LocationOnOutlinedIcon sx={{ fontSize: 42, color: "#8A6A3D" }} />
  //         <h3>No Properties Nearby</h3>
  //         <p>
  //           No buy description properties found within your area.
  //           <br />
  //           <span style={{ fontSize: 12, color: "#8A6A3D" }}>
  //             Try expanding your search or check back later.
  //           </span>
  //         </p>
  //         {userLocation.address && (
  //           <div style={{ fontSize: 12, color: "#6B6350", marginTop: 8 }}>
  //             📍 {userLocation.address}
  //           </div>
  //         )}
  //       </div>
  //       <style>{`
  //         .property-wrapper { width: 100%; padding: 20px 10px; background: rgb(239, 231, 221); }
  //         .no-location-box {
  //           background: #fff;
  //           border-radius: 12px;
  //           padding: 30px 20px;
  //           text-align: center;
  //           box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  //         }
  //         .no-location-box h3 { margin: 10px 0 6px; color: #2E2A22; font-size: 16px; }
  //         .no-location-box p  { margin: 0; color: #6B6350; font-size: 13px; }
  //       `}</style>
  //     </div>
  //   );
  // }

  // ✅ Only take first 3 nearby properties: 1 featured + 2 grid
  const featuredProperty = filteredProperties[0];
  const gridProperties = filteredProperties.slice(1, 3);

  return (
    <div className="property-wrapper">
      {/* 1. FEATURED CARD */}
      {featuredProperty && (
        <div
          className="featured-card-large"
          onClick={() =>
            navigate(`/new-launching-properties/${featuredProperty.id}`)
          }
          style={{ cursor: "pointer" }}
        >
          <div className="featured-content-left">
            <div>
              <div className="price-icon-row">
                <div className="building-icon-circle">
                  <BusinessOutlinedIcon className="building-icon-svg" />
                </div>
                <div className="price-text-block">
                  <h2 className="featured-price">{featuredProperty.price}</h2>
                  <p className="featured-psf">{featuredProperty.pricePerSft}</p>
                </div>
              </div>

              <div className="tags-container">
                {featuredProperty.tags.slice(0, 3).map((tag, idx) => (
                  <span key={idx} className="tag-pill">
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="title-location-block">
              <h3 className="featured-title">{featuredProperty.title}</h3>
              <p className="featured-location-text">
                {featuredProperty.location}
              </p>
              {featuredProperty._distance != null && (
                <p className="featured-distance">
                  📍 {featuredProperty._distance.toFixed(1)} km away
                </p>
              )}
            </div>
          </div>

          <div className="featured-image-right">
            <span className="badge featured-badge">Featured</span>
            <img
              src={
                featuredProperty.image
                  ? `${BASE_URL}${featuredProperty.image}`
                  : "https://via.placeholder.com/300x400?text=Property"
              }
              alt={featuredProperty.title}
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/300x400?text=Property";
              }}
            />
          </div>
        </div>
      )}

      {/* 2. GRID CARDS */}
      {gridProperties.length > 0 && (
        <div className="property-grid">
          {gridProperties.map((property, index) => {
            const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
            const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

            return (
              <div
                key={property.id}
                className="grid-card"
                onClick={() =>
                  navigate(`/new-launching-properties/${property.id}`)
                }
                style={{ cursor: "pointer" }}
              >
                <div className="grid-image-section">
                  <span className={`badge ${badgeClass}`}>{badgeText}</span>
                  <img
                    src={
                      property.image
                        ? `${BASE_URL}${property.image}`
                        : "https://via.placeholder.com/200x200?text=Property"
                    }
                    alt={property.title}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/200x200?text=Property";
                    }}
                  />
                </div>
                <div className="grid-content-section">
                  <h4 className="grid-title">{property.title}</h4>
                  <p className="grid-location">{property.location}</p>
                  <p className="grid-price">{property.price}</p>
                  <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p>
                  {property._distance != null && (
                    <p className="grid-distance">
                      📍 {property._distance.toFixed(1)} km away
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ─── CSS STYLES ────────────────────────────────────────────────────── */}
      <style>{`
        * { box-sizing: border-box; }

        .property-wrapper {
          width: 100%;
          max-width: 500px;
          margin: 0 auto;
          padding: 5px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        }

        /* ── FEATURED LARGE CARD ── */
        .featured-card-large {
          display: grid;
          grid-template-columns: 1fr 1fr;
          background: #F7F2EA;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          margin-bottom: 12px;
          height: 145px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .featured-card-large:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.12);
        }

        .featured-content-left {
          padding: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-width: 0;
          min-height: 0;
          background: #F7F2EA;
          overflow: hidden;
        }

        .price-icon-row {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .building-icon-circle {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: transparent;
          border: 1px solid #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .building-icon-svg {
          color: #000000;
          font-size: 18px;
        }

        .price-text-block { min-width: 0; }

        .featured-price {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          color: #5B4526;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-psf {
          margin: 1px 0 0 0;
          font-size: 14px;
          font-weight: 700;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .tags-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 4px;
          margin-top: 10px;
        }

        .tag-pill {
          background: #cec7c7;
          color: #333333;
          font-size: 11px;
          font-weight: 600;
          padding: 3px 4px;
          border-radius: 20px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border: 1px solid #f0ebe4;
        }

        .title-location-block {
          text-align: center;
          margin-top: 8px;
        }

        .featured-title {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-location-text {
          margin: 3px 0 0 0;
          font-size: 10px;
          font-weight: 600;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-distance {
          margin: 2px 0 0 0;
          font-size: 9px;
          color: #8A6A3D;
          font-weight: 700;
        }

        .featured-image-right {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background: #E8DFD1;
        }

        .featured-image-right img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        /* ── GRID CARDS ── */
        .property-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }

        .grid-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 3px 10px rgba(0,0,0,0.06);
          display: flex;
          flex-direction: column;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .grid-card:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.10);
        }

        .grid-image-section {
          position: relative;
          width: 100%;
          height: 130px;
          overflow: hidden;
          background: #EEE7DD;
        }

        .grid-image-section img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .grid-content-section {
          padding: 10px;
          display: flex;
          flex-direction: column;
          gap: 3px;
          min-height: 0;
        }

        .grid-title {
          margin: 0;
          font-size: 13px;
          font-weight: 800;
          color: #111;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .grid-location {
          margin: 0;
          font-size: 10px;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .grid-price {
          margin: 3px 0 0 0;
          font-size: 14px;
          font-weight: 800;
          color: #d15b1e;
        }

        .grid-details {
          margin: 0;
          font-size: 9px;
          color: #888;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .grid-distance {
          margin: 2px 0 0 0;
          font-size: 9px;
          color: #8A6A3D;
          font-weight: 700;
        }

        /* ── BADGES ── */
        .badge {
          position: absolute;
          top: 8px;
          left: 8px;
          padding: 3px 8px;
          border-radius: 10px;
          font-size: 9px;
          font-weight: 700;
          color: #fff;
          z-index: 2;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .featured-badge { background: #a87c51; }
        .badge-new      { background: #a3a38f; }
        .badge-premium  { background: #d1a47e; }

        @media (max-width: 360px) {
          .grid-image-section { height: 110px; }
          .featured-title { font-size: 11px; }
          .grid-title { font-size: 12px; }
          .featured-card-large { height: 130px; }
          .building-icon-circle { width: 28px; height: 28px; }
          .building-icon-svg { font-size: 16px; }
          .featured-price { font-size: 13px; }
          .featured-psf { font-size: 9px; }
          .tag-pill { font-size: 8px; padding: 2px 3px; }
        }
      `}</style>
    </div>
  );
};

export default BuyDescriptionCard;